import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import store from '@/store'
import { MenuListItem } from '@/store/modules/menu/index'
import FindPassword from '@/views/retrieve-password/index.vue'
import { $t } from '@/lang'

export const defaultRoutes: Array<RouteRecordRaw> = [
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: 'login' */ '@/views/login/index.vue'),
    meta: {
      title: $t('main_menu_route_login')
    }
  },
  {
    path: '/retrieve-password',
    name: 'RetrievePassword',
    component: FindPassword,
    meta: {
      title: $t('main_menu_route_find_password')
    }
  },
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: 'container' */ '@/views/Application.vue')
  },
  {
    path: '/portal:pathMatch(.*)',
    name: 'Portal',
    component: () => import(/* webpackChunkName: 'container' */ '@/views/Application.vue')
  },
  {
    path: '/404',
    name: '404',
    component: () => import(/* webpackChunkName: 'container' */ '@/views/404.vue')
  }
]

const router: any = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [...defaultRoutes]
})

router.beforeEach(async (to: any, from: any, next: any) => {
  history.state.current = from.fullPath

  const state: any = store.state
  // 定义浏览器标签title
  if (to.meta.title) {
    document.title = to.meta.title as string
  }

  if (to.path === '/login') {
    // 如果手动跳转到 login 页面，判断是否登录过，是的话则跳转到首页
    document.title = $t('main_menu_route_login')
    state.user.userInfo && state.env.env ? next('/') : next()
  } else if (to.path === '/retrieve-password') {
    // 判断是否跳转到重置密码页面
    next()
  } else {
    // 获取路径参数
    const query: any = window.location.search.substring(1).split('&') || []
    const vars: any = {}
    if (query.length > 0) {
      query.forEach((item: any) => {
        const objArr = item.split('=')
        vars[objArr[0]] = objArr[1]
      })
    }

    const toUrl = to.path

    // 需要判断登录状态
    // 跳到 login 页面，并存储回调地址
    if (!vars.token && !state.user.userInfo) {
      return next({ name: 'Login', query: { redirect: to.fullPath } })
    }
    if (toUrl === '/') {
      document.title = $t('main_menu_route_work_title')
      store.commit('menu/setCurrentTab', {
        name: $t('main_home_home_name'),
        routeUrl: '/'
      })
      return next()
    } else if (toUrl === '/404') {
      store.commit('menu/setCurrentTab', {
        name: '404',
        routeUrl: '/404'
      })
      return next()
    } else if (!(vars.jumpType === 'SYS' && vars.token)) {
      // 如果是从sys跳转过来的，会触发项目初始化，使用App页面的方法
      const tabList: MenuListItem[] = state.menu.tabList
      const pageList: MenuListItem[] = state.menu.pageList

      const setTabList = (menuItem: MenuListItem) => {
        const isOpen = tabList.some(item => {
          return (
            item.name === menuItem.name ||
            item.routeUrl.split('?')[0] === menuItem.routeUrl.split('?')[0]
          )
        })
        !isOpen && store.commit('menu/addTabMenu', menuItem)
        store.commit('menu/changeCurrentTab', menuItem)
      }
      const title: any = to.query?.title || ''
      const matchedRoute = pageList.find((page: MenuListItem) => {
        return toUrl === page.routeUrl
      })
      if (matchedRoute) {
        let route = to.fullPath
        if (to.hash) {
          route = route.replace(to.hash, '')
        }
        const menuItem = {
          name: (title as string) || matchedRoute.name,
          routeUrl: route
        }
        setTabList(menuItem)
        document.title = $t(menuItem.name)
        next()
      } else {
        document.title = '404'
        const matchLastRoute = pageList.find((page: MenuListItem) => {
          return from.path === page.routeUrl
        })
        if (matchLastRoute) {
          store.commit('menu/setErrorLastRoute', {
            name: matchLastRoute.name,
            routeUrl: from.fullPath
          })
        } else {
          store.commit('menu/setErrorLastRoute', null)
        }
        next('/404')
      }
    } else {
      next()
    }
  }
})

export default router
